import React from "react";
import { IconProps } from "./types";

function IconPhone(props: IconProps) {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="phone 1" clipPath="url(#clip0_1094_45196)">
        <path
          id="Vector"
          d="M11.6 15.1667C8.87819 15.1631 6.26888 14.0803 4.34427 12.1557C2.41966 10.2311 1.33686 7.6218 1.33333 4.89999C1.33333 4.08666 1.65643 3.30665 2.23154 2.73153C2.80665 2.15642 3.58667 1.83333 4.4 1.83333C4.57223 1.83202 4.74416 1.84765 4.91333 1.87999C5.07687 1.9042 5.23764 1.94439 5.39333 1.99999C5.50283 2.03841 5.6004 2.10475 5.6764 2.19244C5.75241 2.28014 5.8042 2.38615 5.82667 2.49999L6.74 6.5C6.76462 6.60857 6.76165 6.72158 6.73137 6.82872C6.7011 6.93585 6.64447 7.0337 6.56667 7.11333C6.48 7.20666 6.47333 7.21333 5.65333 7.64C6.30999 9.08057 7.46213 10.2374 8.9 10.9C9.33333 10.0733 9.34 10.0667 9.43333 9.98C9.51296 9.90219 9.61081 9.84556 9.71794 9.81529C9.82508 9.78501 9.93809 9.78204 10.0467 9.80666L14.0467 10.72C14.1569 10.7456 14.2588 10.7988 14.3427 10.8746C14.4267 10.9504 14.49 11.0463 14.5267 11.1533C14.5829 11.3116 14.6253 11.4744 14.6533 11.64C14.6802 11.8075 14.6935 11.977 14.6933 12.1467C14.681 12.9565 14.3489 13.7286 13.7693 14.2944C13.1898 14.8602 12.4099 15.1738 11.6 15.1667ZM4.4 3.16666C3.94083 3.16842 3.50097 3.3516 3.17629 3.67628C2.8516 4.00097 2.66842 4.44083 2.66667 4.89999C2.66843 7.26872 3.61019 9.53992 5.28513 11.2149C6.96007 12.8898 9.23127 13.8316 11.6 13.8333C12.0592 13.8316 12.499 13.6484 12.8237 13.3237C13.1484 12.999 13.3316 12.5592 13.3333 12.1V11.88L10.24 11.1667L10.0467 11.5333C9.74667 12.1133 9.52667 12.5333 8.96667 12.3067C7.86192 11.9112 6.85913 11.2747 6.03116 10.4432C5.20318 9.61181 4.57081 8.60638 4.18 7.5C3.94 6.98 4.39333 6.74 4.96667 6.43999L5.33333 6.26L4.62 3.16666H4.4Z"
          fill="#1E293B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1094_45196">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default IconPhone;
